import { RGBColor, SelectedCardTrend } from '../../../models/Card';
import { CardViewerItem } from './CardViewerService';

interface TrendCard {
  id: number;
  label: string;
  coordinates: { x: number; y: number }[];
}

interface BuildCardDataForLidarScanResult {
  cardDate: string;
  cardTrends: TrendCard[];
  color: RGBColor;
}

export function buildCardDataForLidarScan(
  asset: CardViewerItem,
  selectedCardTrends: SelectedCardTrend[],
): BuildCardDataForLidarScanResult[] {
  const trends: BuildCardDataForLidarScanResult[] = [];

  for (const trend of selectedCardTrends) {
    const trendId = trend.id;

    let trendCard: TrendCard | null = null;

    if (trendId === 1 && asset.surfaceCard?.coordinates?.length) {
      trendCard = {
        id: 1,
        label: 'Surface Card',
        coordinates: asset.surfaceCard.coordinates,
      };
    } else if (trendId === 2 && asset.pocDownholeCard?.coordinates?.length) {
      trendCard = {
        id: 2,
        label: 'POC Downhole Card',
        coordinates: asset.pocDownholeCard.coordinates,
      };
    } else if (trendId === 3 && asset.xDiagDownholeCard?.coordinates?.length) {
      trendCard = {
        id: 3,
        label: 'XDiag Downhole Card',
        coordinates: asset.xDiagDownholeCard.coordinates,
      };
    } else if (trendId === 9 && asset.loadLimitsAndSetpoints?.length) {
      asset.loadLimitsAndSetpoints.forEach((setpoint) => {
        // Map setpoint names to required IDs
        let mappedId = 7;
        switch (setpoint.name) {
          case 'High Load Limit':
            mappedId = 7;
            break;
          case 'Low Load Limit':
            mappedId = 8;
            break;
          case 'Malfunction Point':
            mappedId = 9;
            break;
          case 'Limit Line':
            mappedId = 14;
            break;
          case 'Fillage Setpoint':
            mappedId = 13;
            break;
          default:
            mappedId = 7;
        }
        trends.push({
          cardDate: asset.lastCardDateFormatted,
          cardTrends: [
            {
              id: mappedId,
              label: setpoint.name,
              coordinates: setpoint.coordinates,
            },
          ],
          color: { r: 239, g: 68, b: 68 },
        });
      });
    } else if (trendId === 5 && asset.permissibleLoadUp?.coordinates?.length) {
      trendCard = {
        id: 5,
        label: 'Permissible Load Up',
        coordinates: asset.permissibleLoadUp.coordinates,
      };
    }

    if (trendCard) {
      trends.push({
        cardDate: asset.lastCardDateFormatted,
        cardTrends: [trendCard],
        color: { r: 239, g: 68, b: 68 },
      });
    }
  }

  return trends;
}
